
const Point = require("./Point");

function Transformation(opts) {
    Object.assign(this, opts || {});
}

Transformation.IDENTITY = new Transformation();

Object.assign(Transformation.prototype, {
    zoom: 1,
    xTranslation: 0,
    yTranslation: 0
});

Transformation.prototype.getX = function () {
    return this.xTranslation;
};

Transformation.prototype.getY = function () {
    return this.yTranslation;
};

Transformation.prototype.getZoom = function () {
    return this.zoom;
}

Transformation.prototype.translatePoint = function (point) {
    return Point.mk((point.x + this.xTranslation) * this.zoom, (point.y + this.yTranslation) * this.zoom);
};

module.exports = Transformation;

